'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flatArray = flatArray;
exports.treeMap = treeMap;
exports.isMultiTh = isMultiTh;
exports.getValidColumns = getValidColumns;
exports.filterColumns = filterColumns;

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _lodashCompat = require('lodash-compat');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

function flatArray() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
  var childrenName = arguments.length <= 1 || arguments[1] === undefined ? 'children' : arguments[1];

  var result = [];
  var loop = function loop(array) {
    array.forEach(function (item) {
      var newItem = (0, _objectAssign2.default)({}, item);
      delete newItem[childrenName];
      result.push(newItem);
      if (item[childrenName] && item[childrenName].length > 0) {
        loop(item[childrenName]);
      }
    });
  };
  loop(data);
  return result;
}

function treeMap(tree, mapper) {
  var childrenName = arguments.length <= 2 || arguments[2] === undefined ? 'children' : arguments[2];

  return tree.map(function (node, index) {
    var extra = {};
    if (node[childrenName]) {
      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
    }
    return (0, _objectAssign2.default)({}, mapper(node, index), extra);
  });
}
function isMultiTh(_ref) {
  var columns = _ref.columns;

  if (!columns || columns.length === 0) return;
  return columns.every(function (col) {
    return Array.isArray(col);
  });
}
/**
 * 获取列配置
 * @param columns 当前列的配置
 * @param lastCol 如果不传, 则返回有效的列, 否则将有效的列更新后返回全部的配置
 * @returns {*}
 */
function getValidColumns(_ref2, lastCol) {
  var columns = _ref2.columns;

  if (!columns) return null;
  if (!isMultiTh({ columns: columns })) return lastCol || columns;
  if (lastCol) {
    columns.splice(columns.length - 1, 1, lastCol);
    return columns;
  }
  if (columns.length > 0 && columns.every(function (v) {
    return Array.isArray(v);
  })) {
    return columns[columns.length - 1];
  }
}
/**
 * 有固定列, 合并表头需要拆分
 * @param columns 当前列的配置
 * @param fCols 固定的列
 */
function filterColumns(_ref3, fCols) {
  var columns = _ref3.columns;

  if (!columns || !fCols) return null;
  if (!isMultiTh({ columns: columns })) return fCols;
  columns = (0, _lodashCompat.cloneDeep)(columns);
  var indexs = fCols.map(function (col) {
    return columns[columns.length - 1].findIndex(function (v) {
      return v.key === col.key;
    });
  });
  if (indexs.some(function (v) {
    return v === -1;
  })) return fCols;
  var sum = 0;
  columns = columns.slice(0, columns.length - 1).map(function (col) {
    return col.filter(function (row) {
      var _sum = sum + (row.colSpan || 1);
      if (indexs.some(function (index) {
        return sum < index + 1 && _sum >= index + 1;
      })) {
        sum = _sum;
        return true;
      }
      sum = _sum;
    }).map(function (v) {
      v.colSpan = 1;
      return v;
    });
  });
  columns.push(fCols);
  return columns;
}